import * as React from 'react';
import { LeadingContentType, StyleVariant } from '../AmorgMenuTypes';
import { NoneContent } from '../baseContentTypes/NoneContent';
import { IconContent } from '../baseContentTypes/IconContent';

type LeadingContentProps = LeadingContentType &
{
    styleVariant:StyleVariant,
    isHovering:boolean,
    onClick?:()=>void
}

export function LeadingContent(props:LeadingContentProps):JSX.Element
{
    return (
        <>
            {props.type === 'none' &&
                <NoneContent />    
            }

            {props.type === 'icon' &&
                <IconContent 
                    type='icon' 
                    iconName={props.iconName} 
                    styleVariant={props.styleVariantOverride || props.styleVariant}
                    isHovering={props.onClick && props.isHovering} />
            }
        </>
    );
}